import { render, staticRenderFns } from "./Perintah.vue?vue&type=template&id=8537d98a&"
import script from "./Perintah.vue?vue&type=script&lang=js&"
export * from "./Perintah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports